export default "shared/select2.min.ae5735562faabd1a.css"